import React from "react";

import { usePrivacyViewModel } from "./usePrivacyViewModel";
import { s } from "./PrivacyStyles";

type Props = {
    onBack?: () => void;
};

export default function PrivacyScreen(props: Props) {
    const vm = usePrivacyViewModel();

    return (
        <div className={s.page}>

            {/* Progress Bar */}
            <div className={s.progressContainer}>
                <div
                    className={s.progressBar}
                    style={{
                        width: `${vm.scrollProgress}%`,
                    }}
                />
            </div>


            {/* Floating Header */}
            <div
                className={`${s.header} ${vm.showHeader ? s.headerVisible : ""
                    }`}
            >
                <div className={s.headerInner}>

                    <div className={s.headerLeft}>
                        <span className={s.headerLogo}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <defs>
                                    <radialGradient id="g10" cx="42%" cy="32%" r="68%">
                                        <stop offset="0%" stopColor="#33344A" />
                                        <stop offset="50%" stopColor="#1A1A2E" />
                                        <stop offset="100%" stopColor="#08080F" />
                                    </radialGradient>
                                </defs>

                                <circle cx="100" cy="100" r="100" fill="url(#g10)" />

                                {[-70, -42, -14, 14, 42, 70].map((r) => (
                                    <path
                                        key={r}
                                        d="M100,118 C83,96 85,56 100,35 C115,56 117,96 100,118"
                                        fill="rgba(255,255,255,.13)"
                                        stroke="rgba(160,215,255,.45)"
                                        strokeWidth="1.1"
                                        transform={`rotate(${r},100,118)`}
                                    />
                                ))}

                                {[-28, 0, 28].map((r) => (
                                    <path
                                        key={r}
                                        d="M100,118 C87,100 89,70 100,53 C111,70 113,100 100,118"
                                        fill="rgba(140,200,255,.72)"
                                        stroke="rgba(160,215,255,.92)"
                                        strokeWidth="1"
                                        transform={`rotate(${r},100,118)`}
                                    />
                                ))}

                                {[-13, 0, 13].map((r) => (
                                    <path
                                        key={r}
                                        d="M100,118 C93,104 94,83 100,70 C106,83 107,104 100,118"
                                        fill="rgba(255,255,255,.45)"
                                        stroke="rgba(255,255,255,.62)"
                                        strokeWidth="0.9"
                                        transform={`rotate(${r},100,118)`}
                                    />
                                ))}

                                <circle cx="100" cy="75" r="1.4" fill="rgba(255,255,255,.88)" />
                                <circle cx="92" cy="86" r="0.9" fill="rgba(255,255,255,.72)" />
                                <circle cx="109" cy="83" r="0.9" fill="rgba(255,255,255,.72)" />
                                <circle cx="100" cy="118" r="3.8" fill="rgba(255,255,255,.93)" />
                            </svg>
                        </span>

                        <span className={s.barTitle}>
                            Tullu
                        </span>

                        <span className={s.barDivider}>·</span>

                        <span className={s.barSubtitle}>
                            Privacy Policy
                        </span>
                    </div>

                    <a href="#top" className={s.topButton}>
                        TOP

                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.4"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M12 19V5M5 12l7-7 7 7" />
                        </svg>
                    </a>

                </div>
            </div>

            {/* Top Anchor */}
            <div id="top" />

            {/* Document */}
            <div className={s.wrap}>
                <header className={s.docHeader}>

                    <div className={s.eyebrow}>
                        <span className={s.brandMark}>
                            <svg
                                width="30"
                                height="30"
                                viewBox="0 0 200 200"
                                xmlns="http://www.w3.org/2000/svg"
                                className="shrink-0"
                            >
                                <defs>
                                    <radialGradient id="g8" cx="42%" cy="32%" r="68%">
                                        <stop offset="0%" stopColor="#33344A" />
                                        <stop offset="50%" stopColor="#1A1A2E" />
                                        <stop offset="100%" stopColor="#08080F" />
                                    </radialGradient>
                                </defs>

                                <circle cx="100" cy="100" r="100" fill="url(#g8)" />

                                {[-70, -42, -14, 14, 42, 70].map((r) => (
                                    <path
                                        key={r}
                                        d="M100,118 C83,96 85,56 100,35 C115,56 117,96 100,118"
                                        fill="rgba(255,255,255,.13)"
                                        stroke="rgba(160,215,255,.45)"
                                        strokeWidth="1.1"
                                        transform={`rotate(${r},100,118)`}
                                    />
                                ))}

                                {[-28, 0, 28].map((r) => (
                                    <path
                                        key={r}
                                        d="M100,118 C87,100 89,70 100,53 C111,70 113,100 100,118"
                                        fill="rgba(140,200,255,.72)"
                                        stroke="rgba(160,215,255,.92)"
                                        strokeWidth="1"
                                        transform={`rotate(${r},100,118)`}
                                    />
                                ))}

                                {[-13, 0, 13].map((r) => (
                                    <path
                                        key={r}
                                        d="M100,118 C93,104 94,83 100,70 C106,83 107,104 100,118"
                                        fill="rgba(255,255,255,.45)"
                                        stroke="rgba(255,255,255,.62)"
                                        strokeWidth="0.9"
                                        transform={`rotate(${r},100,118)`}
                                    />
                                ))}

                                <circle cx="100" cy="75" r="1.4" fill="rgba(255,255,255,.88)" />
                                <circle cx="92" cy="86" r="0.9" fill="rgba(255,255,255,.72)" />
                                <circle cx="109" cy="83" r="0.9" fill="rgba(255,255,255,.72)" />
                                <circle cx="100" cy="118" r="3.8" fill="rgba(255,255,255,.93)" />
                            </svg>
                        </span>

                        <span className={s.brandName}>
                            Tullu Technologies · Partner
                        </span>
                    </div>

                    {/* TWO COLUMN LAYOUT */}
                    <div className={s.heroGrid}>

                        <div className={s.heroLeft}>

                            <h1 className={s.title}>
                                Partner App
                                <br />
                                Privacy Policy
                            </h1>

                            <p className={s.lede}>
                                Tullu is committed to protecting your privacy and your clients' data. This policy explains how we collect, use, disclose, and safeguard your information when you use the Tullu Partner App.
                            </p>
                            <div className={s.meta}>
                                <div className={s.metaItem}>
                                    <span className={s.metaLabel}>Effective</span>
                                    <span className={s.metaValue}>May 10, 2026</span>
                                </div>

                                <div className={s.metaItem}>
                                    <span className={s.metaLabel}>Applies to</span>
                                    <span className={s.metaValue}>Tullu Partner App</span>
                                </div>

                                <div className={s.metaItem}>
                                    <span className={s.metaLabel}>Version</span>
                                    <span className={s.metaValue}>1.0</span>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className={s.disclosure}>
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#147A59"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className={s.disclosureIcon}
                        >
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        </svg>

                        <p className={s.disclosureText}>
                            <strong>For HIPAA-covered practices,</strong>{" "}
                            Tullu acts as your Business Associate for protected health
                            information in the Platform. We protect your data with encryption
                            and <strong>never sell your personal information.</strong>
                        </p>
                    </div>

                </header>
            </div>

            {/* Content */}
            <section className={s.contentSection}>
                <div className={s.contentWrapper}>

                    {/* Desktop TOC */}
                    <aside className={s.sidebar}>

                        <div className={s.sidebarCard}>

                            <h3 className={s.sidebarTitle}>
                                On this page
                            </h3>

                            <div className={s.sidebarLinks}>

                                {vm.sections.map((section) => (

                                    <button
                                        key={section.id}
                                        type="button"
                                        onClick={() => vm.scrollToSection(section.id)}
                                        className={`${s.sidebarLink} ${vm.activeSection === section.id
                                            ? s.sidebarLinkActive
                                            : ""
                                            }`}
                                    >
                                        {section.title}
                                    </button>

                                ))}

                            </div>

                        </div>

                    </aside>

                    {/* Main Content */}
                    <main className={s.article}>

                        {vm.sections.map((section) => (

                            <section
                                key={section.id}
                                id={section.id}
                                className={s.section}
                            >

                                <div className={s.sectionHeader}>

                                    <span className={s.sectionNumber}>
                                        {section.number}
                                    </span>

                                    <h2 className={s.sectionTitle}>
                                        {section.title}
                                    </h2>

                                </div>

                                <div className={s.sectionContent}>

                                    {section.content?.map((paragraph, index) => (
                                        <p
                                            key={index}
                                            className={s.paragraph}
                                        >
                                            {paragraph}
                                        </p>
                                    ))}

                                    {section.bullets && (
                                        <ul className={s.cleanList}>
                                            {section.bullets.map((item, index) => (
                                                <li
                                                    key={index}
                                                    className={s.cleanListItem}
                                                >
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}

                                    {section.subHeading && (
                                        <h4 className={s.subHeading}>
                                            {section.subHeading}
                                        </h4>
                                    )}

                                    {section.bullets2 && (
                                        <ul className={s.cleanList}>
                                            {section.bullets2.map((item, index) => (
                                                <li
                                                    key={index}
                                                    className={s.cleanListItem}
                                                >
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}



                                    {/* Groups */}
                                    {section.groups?.map((group, index) => (
                                        <div
                                            key={index}
                                            className={`${s.group} ${section.id === "hipaa-protected-health-information"
                                                ? s.hipaaCard
                                                : ""
                                                }`}
                                        >
                                            <h4
                                                className={
                                                    section.id === "hipaa-protected-health-information"
                                                        ? s.hipaaTitle
                                                        : s.groupTitle
                                                }
                                            >
                                                {group.heading}
                                            </h4>

                                            {group.content?.map((paragraph, i) => (
                                                <p
                                                    key={i}
                                                    className={s.paragraph}
                                                >
                                                    {paragraph}

                                                    {group.link && i === (group.content?.length ?? 0) - 1 && (
                                                        <>
                                                            {" "}
                                                            See our{" "}
                                                            <a
                                                                href={group.link.href}
                                                                className={s.link}
                                                            >
                                                                {group.link.label}
                                                            </a>{" "}
                                                            for details.
                                                        </>
                                                    )}
                                                </p>
                                            ))}

                                            {group.bullets && (
                                                <ul className={s.cleanList}>
                                                    {group.bullets.map((item, i) => (
                                                        <li
                                                            key={i}
                                                            className={s.cleanListItem}
                                                        >
                                                            {item}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}

                                            {group.footer && (
                                                <p className={s.paragraph}>
                                                    {group.footer}

                                                    {group.footerLink && (
                                                        <>
                                                            {" "}
                                                            <a
                                                                href={group.footerLink.href}
                                                                className={s.link}
                                                            >
                                                                {group.footerLink.label}
                                                            </a>
                                                        </>
                                                    )}
                                                </p>
                                            )}
                                        </div>
                                    ))}

                                    {section.footer && (
                                        <p className={s.paragraph}>
                                            {section.footer}
                                        </p>
                                    )}

                                    {section.contact && (
                                        <div className={s.contactCard}>
                                            <h4 className={s.org}>
                                                {section.contact.organization}
                                            </h4>

                                            <p className={s.contactRow}>
                                                <strong>Legal:</strong>{" "}
                                                <a
                                                    href={`mailto:${section.contact.legal}`}
                                                    className={s.link}
                                                >
                                                    {section.contact.legal}
                                                </a>
                                            </p>

                                            <p className={s.contactRow}>
                                                <strong>Support:</strong>{" "}
                                                <a
                                                    href={`mailto:${section.contact.support}`}
                                                    className={s.link}
                                                >
                                                    {section.contact.support}
                                                </a>
                                            </p>

                                            <p className={s.contactRow}>
                                                <strong>Website:</strong>{" "}
                                                <a
                                                    href="https://tulluapp.com"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className={s.link}
                                                >
                                                    {section.contact.website}
                                                </a>
                                            </p>
                                        </div>
                                    )}

                                    {section.agreement && (
                                        <div className={s.affirm}>
                                            <h3 className={s.affirmTitle}>
                                                {section.agreement.title}
                                            </h3>

                                            <p className={s.affirmDesc}>
                                                {section.agreement.description}
                                            </p>
                                        </div>
                                    )}

                                </div>
                            </section>

                        ))}

                    </main>

                </div>
            </section>

            {/* Footer */}

            <footer className={s.footer}>
                <div className={s.footerInner}>

                    <div className={s.footerBrand}>
                        <div className={s.footerLogo}>  <svg
                            width="30"
                            height="30"
                            viewBox="0 0 200 200"
                            xmlns="http://www.w3.org/2000/svg"
                            className="shrink-0"
                        >
                            <defs>
                                <radialGradient id="g8" cx="42%" cy="32%" r="68%">
                                    <stop offset="0%" stopColor="#33344A" />
                                    <stop offset="50%" stopColor="#1A1A2E" />
                                    <stop offset="100%" stopColor="#08080F" />
                                </radialGradient>
                            </defs>

                            <circle cx="100" cy="100" r="100" fill="url(#g8)" />

                            {[-70, -42, -14, 14, 42, 70].map((r) => (
                                <path
                                    key={r}
                                    d="M100,118 C83,96 85,56 100,35 C115,56 117,96 100,118"
                                    fill="rgba(255,255,255,.13)"
                                    stroke="rgba(160,215,255,.45)"
                                    strokeWidth="1.1"
                                    transform={`rotate(${r},100,118)`}
                                />
                            ))}

                            {[-28, 0, 28].map((r) => (
                                <path
                                    key={r}
                                    d="M100,118 C87,100 89,70 100,53 C111,70 113,100 100,118"
                                    fill="rgba(140,200,255,.72)"
                                    stroke="rgba(160,215,255,.92)"
                                    strokeWidth="1"
                                    transform={`rotate(${r},100,118)`}
                                />
                            ))}

                            {[-13, 0, 13].map((r) => (
                                <path
                                    key={r}
                                    d="M100,118 C93,104 94,83 100,70 C106,83 107,104 100,118"
                                    fill="rgba(255,255,255,.45)"
                                    stroke="rgba(255,255,255,.62)"
                                    strokeWidth="0.9"
                                    transform={`rotate(${r},100,118)`}
                                />
                            ))}

                            <circle cx="100" cy="75" r="1.4" fill="rgba(255,255,255,.88)" />
                            <circle cx="92" cy="86" r="0.9" fill="rgba(255,255,255,.72)" />
                            <circle cx="109" cy="83" r="0.9" fill="rgba(255,255,255,.72)" />
                            <circle cx="100" cy="118" r="3.8" fill="rgba(255,255,255,.93)" />
                        </svg></div>

                        <p className={s.footerSub}>
                            Tullu is the practice-management platform and client
                            marketplace for licensed beauty, wellness, and
                            medical-esthetic providers in Arizona.
                        </p>
                    </div>

                    <div className={s.footerColumn}>
                        <h4 className={s.footerHeading}>Legal</h4>

                        <div className={s.footerLinks}>
                            <a href="#" className={s.footerLink}>Privacy Policy</a>
                            <a href="/terms" className={s.footerLink}>Terms of Service</a>
                            <a href="#" className={s.footerLink}>SMS Consent</a>
                            <a href="#" className={s.footerLink}>HIPAA Notice</a>
                        </div>
                    </div>

                    <div className={s.footerColumn}>
                        <h4 className={s.footerHeading}>Support</h4>

                        <div className={s.footerLinks}>
                            <a href="mailto:legal@tulluapp.com" className={s.footerLink}>
                                legal@tulluapp.com
                            </a>

                            <a href="mailto:support@tulluapp.com" className={s.footerLink}>
                                support@tulluapp.com
                            </a>

                            <a
                                href="https://tulluapp.com"
                                target="_blank"
                                rel="noreferrer"
                                className={s.footerLink}
                            >
                                tulluapp.com
                            </a>
                        </div>
                    </div>

                </div>

                <div className={s.footerBottom}>
                    <span className={s.footerCopy}>
                        © 2026 Tullu Technologies LLC • Phoenix, Arizona
                    </span>

                    <span className={s.footerUpdated}>
                        Last updated May 10, 2026
                    </span>
                </div>
            </footer>

            {/* Back To Top */}
            <button
                type="button"
                aria-label="Back to top"
                className={`${s.backToTop} ${vm.scrollProgress > 1
                    ? s.backToTopVisible
                    : ""
                    }`}
                onClick={vm.scrollToTop}
            >
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M12 19V5M5 12l7-7 7 7" />
                </svg>
            </button>

        </div>
    );
}